import dynamic from "next/dynamic";

const ReactECharts = dynamic(
	() => import("echarts-for-react").then((mod) => mod.default),
	{ ssr: false },
) as any;

interface SimplePieChartProps {
	data: Record<string, number>;
}

const SimplePieChart = ({ data }: SimplePieChartProps) => {
	const total = Object.values(data).reduce((acc, val) => acc + val, 0);
	if (total === 0) return null;

	const entries = Object.entries(data)
		.filter(([, count]) => count > 0)
		.map(([key, count]) => ({ value: count, name: key }));

	const option = {
		tooltip: {
			trigger: "item",
			formatter:
				'<div class="capitalize font-medium dark:text-slate-700">{b}</div>{c} questions ({d}%)',
		},
		legend: {
			bottom: "0%",
			left: "center",
			icon: "circle",
			itemWidth: 10,
			itemHeight: 10,
			textStyle: { color: "#64748b" },
			formatter: (name: string) => name.charAt(0).toUpperCase() + name.slice(1),
		},
		series: [{ type: "pie", avoidLabelOverlap: true, data: entries }],
	};

	return (
		<div className="mb-4 flex h-60 w-full justify-center">
			<ReactECharts
				option={option}
				style={{ height: "240px", width: "100%" }}
			/>
		</div>
	);
};

export default SimplePieChart;
